import React, { useState } from "react";
import clsx from "clsx";
import { Link } from "gatsby";
import logo from "../../images/logo.jpeg";

const links = [
  {
    name: "Courses",
    subroutes: [
      { name: "CAH", href: "/courses/certificate-in-aviation-and-hospitality" },
      { name: "CHM", href: "/courses/certificate-in-hospitality-management" },
      {
        name: "CCAH",
        href: "/courses/comprehensive-certificate-in-aviation-and-hospitality",
      },
      {
        name: "CCHM",
        href:
          "/courses/comprehensive-certificate-in-hospitality-and-retail-management",
      },
    ],
  },
  { name: "About", href: "/#about" },
  { name: "Gallery", href: "/#gallery" },
  { name: "Admission", href: "/#admission" },
  { name: "Career", href: "/#career" },
  { name: "Contact Us", href: "/#contact" },
];

export default function Navbar() {
  // const router = useRouter();
  // const activeHashRoute = router.asPath.match(/#([a-z0-9]+)/gi);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [coursesDropdownVisible, setCoursesDropdownVisible] = useState(false);

  const isHrefActive = (url) => {
    return false;
    // if (activeHashRoute) {
    //   return activeHashRoute[0] === url;
    // } else {
    //   return router.pathname === url;
    // }
  };

  return (
    <div className="fixed z-10 top-0 left-0 w-full">
      <nav className="bg-black">
        <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
          <div className="relative flex items-center justify-between h-16">
            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
              <button
                onClick={() => setDropdownVisible(!dropdownVisible)}
                type="button"
                className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                aria-controls="mobile-menu"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
                <svg
                  className="hidden h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
              <div className="flex-shrink-0 flex items-center">
                <Link to="/">
                  <img
                    className="block h-10 w-auto"
                    src={logo}
                    alt="Workflow"
                  />
                </Link>
              </div>
              <div className="hidden sm:block sm:ml-6"></div>
            </div>
            <div className="sm:block hidden absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
              <div className="flex space-x-4">
                {links.map((link, i) => {
                  const linkClassNames = clsx([
                    { "bg-gray-700": isHrefActive(link.href) },
                    "text-white cursor-pointer hover:bg-gray-200 hover:text-gray-900 px-2 py-1.5 rounded-md text-sm font-medium",
                  ]);

                  if (link.subroutes) {
                    return (
                      <div
                        onMouseLeave={() => setCoursesDropdownVisible(false)}
                        className={clsx([linkClassNames, "relative"])}
                      >
                        <span
                          onMouseEnter={() => setCoursesDropdownVisible(true)}
                        >
                          {link.name}
                        </span>
                        <ul
                          className={clsx(
                            {
                              "pointer-events-auto opacity-100": coursesDropdownVisible,
                            },
                            "absolute transition-500 transition-all pointer-events-none opacity-0 font-semibold mt-2 rounded-md p-2 bg-gray-200 left-1/2 transform -translate-x-1/2 top-100"
                          )}
                        >
                          {link.subroutes.map((route, i) => {
                            return (
                              <li
                                className={clsx(
                                  {
                                    "border-t mt-1 pt-1": i !== 0,
                                  },
                                  "border-gray-500 hover:text-red-500 text-center"
                                )}
                                key={i}
                              >
                                <Link to={route.href}>{route.name}</Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    );
                  }

                  return (
                    <Link key={i} to={link.href} className={linkClassNames}>
                      {link.name}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ display: dropdownVisible ? "block" : "none" }}
          className="sm:hidden"
          id="mobile-menu"
        >
          <div className="px-2 pt-2 pb-3 space-y-1">
            {links.map((link, i) => {
              return (
                <a
                  key={i}
                  href={link.href}
                  className={clsx([
                    { "bg-gray-700": isHrefActive(link.href) },
                    "text-white hover:bg-gray-200 hover:text-gray-900 block px-3 py-2 rounded-md text-base font-medium",
                  ])}
                >
                  {link.name}
                </a>
              );
            })}
          </div>
        </div>
      </nav>
    </div>
  );
}
